import React from "react";
import ConnectedRecurringSummaryHistoryListItem from "./ConnectedRecurringSummaryHistoryListItem";
import "./RecurringSummaryHistoryList.scss";

/**
 * @param {object} props
 * @param {string} props.dateLabel
 * @param {Function} props.handleClick
 * @param {string} props.statusLabel
 * @param {Array} props.transactionHistory
 * @param {string} props.transactionIdLabel
 * @returns {React.JSX.Element}
 */
const RecurringSummaryHistoryList = ({
    dateLabel,
    handleClick,
    statusLabel,
    transactionHistory,
    transactionIdLabel,
}) =>
    transactionHistory.map((currentTransHistory, index) => (
        <ConnectedRecurringSummaryHistoryListItem
            key={
                currentTransHistory?.receiptId
                    ? currentTransHistory.receiptId
                    : currentTransHistory.id
            }
            currentIndex={index}
            currentTransHistory={currentTransHistory}
            dateLabel={dateLabel}
            handleClick={handleClick}
            index={index}
            statusLabel={statusLabel}
            transactionIdLabel={transactionIdLabel}
        />
    ));

export default RecurringSummaryHistoryList;
